import React from "react";

export const AdminLogoutComponent = React.memo(() => {
    return (<></>);
});